import styled from 'styled-components';

export const HeaderContainer = styled.header`
  background: #fff;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;

  @media (max-width: 480px) {
    padding: 0.75rem 0;
  }
`;

export const Logo = styled.div`
  h1 {
    color: #2563eb;
    font-size: 1.8rem;
    margin: 0;
    font-weight: 700;

    @media (max-width: 480px) {
      font-size: 1.5rem;
    }
  }
`;

export const Tagline = styled.span`
  font-size: 0.9rem;
  color: #6b7280;
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const Nav = styled.nav`
  @media (max-width: 768px) {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    transform: ${props => props.isOpen ? 'translateY(0)' : 'translateY(-100%)'};
    opacity: ${props => props.isOpen ? '1' : '0'};
    visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
    transition: all 0.3s ease;
  }
`;

export const NavList = styled.ul`
  display: flex;
  list-style: none;
  gap: 2rem;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
    gap: 0;
  }
`;

export const NavItem = styled.li`
  @media (max-width: 768px) {
    border-bottom: 1px solid #e5e7eb;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const NavLink = styled.a`
  text-decoration: none;
  color: #374151;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  display: block;
  padding: ${props => props.isMobile ? '1rem 0' : '0'};

  &:hover {
    color: #2563eb;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background: #2563eb;
    transition: width 0.3s ease;

    @media (max-width: 768px) {
      display: none;
    }
  }

  &:hover::after {
    width: 100%;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const PhoneBtn = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: #2563eb;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border: 2px solid #2563eb;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: #2563eb;
    color: white;
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

export const PhoneIcon = styled.span`
  font-size: 1.2rem;
`;

export const PhoneText = styled.span`
  font-size: 0.9rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MenuToggle = styled.button`
  display: none;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: flex;
  }

  span {
    width: 25px;
    height: 3px;
    background: #374151;
    transition: all 0.3s ease;
    border-radius: 2px;
    transform-origin: center;

    &:nth-child(1) {
      transform: ${props => props.isOpen ? 'rotate(45deg) translate(6px, 6px)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${props => props.isOpen ? '0' : '1'};
    }

    &:nth-child(3) {
      transform: ${props => props.isOpen ? 'rotate(-45deg) translate(6px, -6px)' : 'none'};
    }
  }
`;
